import styled from 'styled-components';

export const StyledRibbon = styled.div`
  > div:first-child {
    padding: 0;
    padding-top: 4px;
  }
`;
